import React, { useState, useContext } from 'react'
import { bool, node } from 'prop-types'

const AuthenticationContext = React.createContext({})

AuthenticationContextProvider.propTypes = {
  initialAuthenticationRequired: bool,
  children: node
}

function AuthenticationContextProvider ({ initialAuthenticationRequired = false, children }) {
  const [isAuthenticationRequired, setAuthenticationRequired] = useState(initialAuthenticationRequired)

  return (
    <AuthenticationContext.Provider value={{ isAuthenticationRequired, setAuthenticationRequired }}>
      {children}
    </AuthenticationContext.Provider>
  )
}

function useAuthenticationContext () {
  return useContext(AuthenticationContext)
}

export default AuthenticationContext

export { AuthenticationContextProvider, useAuthenticationContext }
